import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';

declare global {
  interface Window {
    Cookiebot?: any;
    gtag: any;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterModule, CommonModule]
})
export class AppComponent implements OnInit {
  isIframe = false;

  constructor(
    private router: Router,
    private authService: MsalService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;

    this.authService.handleRedirectObservable().subscribe({
      next: (result) => {
        if (result) {
          this.authService.instance.setActiveAccount(result.account);
        }
      },
      error: (error) => console.error('MSAL Redirect Error:', error)
    });

    // 1. Escuta o evento do Cookiebot para quando o usuário aceitar os cookies (ou se já tiver aceitado no passado)
    window.addEventListener('CookiebotOnAccept', () => {
      this.dispararPageviewAtual();
    });

    // 2. Escuta as mudanças de rota
    this.router.events.pipe(
      filter((evt): evt is NavigationEnd => evt instanceof NavigationEnd)
    ).subscribe((evt: NavigationEnd) => {
      window.scrollTo(0, 0);
      
      // Dispara o pageview se o Analytics já estiver liberado e carregado
      this.dispararPageviewAtual();      

      // Força o Cookiebot a reavaliar elementos injetados dinamicamente na nova rota
      try {
        if (window.Cookiebot && typeof window.Cookiebot.runScripts === 'function') {
          window.Cookiebot.runScripts();
        }
      } catch (e) {
        console.error('Erro ao executar scripts do Cookiebot:', e);
      }
    });
  }

  /**
   * Método auxiliar para centralizar o disparo do Google Analytics
   */
  private dispararPageviewAtual(): void {
    const urlAtual = this.router.url;
    const isPublicArea = !urlAtual.startsWith('/cms');

    // Só dispara se for área pública, se o gtag existir e se o usuário deu consentimento para estatísticas
    if (isPublicArea && window.gtag && window.Cookiebot?.consent?.statistics) {
      window.gtag('config', 'G-M37KPBJDD6', {
        'page_path': urlAtual
      });
    }
  }
}